import {h, Fragment} from "preact"
import { SearchResultsV2 as SearchResults } from '../'

export default function Automcomplete () {
    return (
        <SearchResults />
    )
}